// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__Fv1ma","footer":"ReportModalFilter_footer__lmxQg"};